import { Link } from "react-router-dom";
import { SITE, NAV_LINKS } from "@/lib/site";

const legal = [
  { label: "Privacy Policy", to: "/privacy-policy", testId: "footer-privacy-link" },
  { label: "Terms of Use", to: "/terms-of-use", testId: "footer-terms-link" },
  { label: "Returns Policy", to: "/returns-policy", testId: "footer-returns-link" },
];

export const Footer = () => (
  <footer data-testid="site-footer" className="mt-auto bg-[#0B1F33] text-white">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 py-16 lg:grid-cols-4 lg:px-8 lg:py-20">
      <div className="lg:col-span-2">
        <p className="font-[Manrope] text-xl font-extrabold tracking-tight">
          Auto<span className="text-[#4E93F5]">Neova</span>
        </p>
        <p className="mt-3 text-sm font-medium text-white/90">{SITE.legalName}</p>
        <p className="mt-1 text-sm text-white/70">{SITE.tagline}</p>
        <address className="mt-4 text-sm not-italic text-white/70" data-testid="footer-registered-address">
          <span className="block text-xs font-semibold uppercase tracking-wider text-white/50">
            Registered Business Address
          </span>
          {SITE.address.line1}
          <br />
          {`${SITE.address.city}, ${SITE.address.state} ${SITE.address.postalCode}`}
        </address>
        <p className="mt-5 text-sm text-white/70">
          Email:{" "}
          <a
            href={`mailto:${SITE.email}`}
            data-testid="footer-email-link"
            className="font-medium text-white underline decoration-white/40 underline-offset-4 transition-colors hover:decoration-white"
          >
            {SITE.email}
          </a>
        </p>
        <p className="mt-1 text-sm text-white/70">
          Website:{" "}
          <span className="font-medium text-white">{SITE.website}</span>
        </p>
      </div>

      <div>
        <h2 className="text-sm font-semibold uppercase tracking-wider text-white">Company</h2>
        <ul className="mt-5 space-y-3">
          {NAV_LINKS.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={`footer-${l.testId}`}
                className="text-sm text-white/75 transition-colors hover:text-white"
              >
                {l.label}
              </Link>
            </li>
          ))}
          <li>
            <a
              href={SITE.amazonStore}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-amazon-link"
              className="text-sm text-white/75 transition-colors hover:text-white"
            >
              AutoNeova on Amazon
            </a>
          </li>
        </ul>
      </div>

      <div>
        <h2 className="text-sm font-semibold uppercase tracking-wider text-white">Legal</h2>
        <ul className="mt-5 space-y-3">
          {legal.map((l) => (
            <li key={l.to}>
              <Link
                to={l.to}
                data-testid={l.testId}
                className="text-sm text-white/75 transition-colors hover:text-white"
              >
                {l.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-7xl flex-col gap-3 px-5 py-6 text-xs text-white/60 lg:flex-row lg:items-center lg:justify-between lg:px-8">
        <p data-testid="footer-copyright">
          Copyright &copy; 2026 AutoNeova. All rights reserved.
        </p>
        <p>
          AutoNeova operates independently and is not affiliated with, sponsored by, or endorsed
          by Amazon or any vehicle manufacturer.
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
